<template>
  <form @submit.prevent="handleSubmit(item)">
<!--    <div class="form-group">-->
<!--      <label-->
<!--        for="excmcaseproblem_idProblem"-->
<!--        class="form-control-label">idProblem</label>-->
<!--      <input-->
<!--        id="excmcaseproblem_idProblem"-->
<!--        v-model="item.idProblem"-->
<!--        :class="['form-control', isInvalid('idProblem') ? 'is-invalid' : '']"-->
<!--        type="text"-->
<!--        required="true"-->
<!--        placeholder=""-->
<!--        @input="handleUpdateField('idProblem', $event.target.value)">-->
<!--      <div-->
<!--        v-if="isInvalid('idProblem')"-->
<!--        class="invalid-feedback">{{ violations.idProblem }}</div>-->
<!--    </div>-->
    <div :class="['form-group', isInvalid('idProblem') ? 'has-danger' : '']">
      <label
        for="excmcaseproblem_idProblem"
        class="form-control-label">{{$t('views.excmcaseproblem.form.idProblem')}}</label>
      <fg-input :error="violations.idProblem">
        <el-select
          id="excmcaseproblem_idProblem"
          :class="['select-default', isInvalid('idProblem') ? 'select-danger' : '']"
          :placeholder="$t('views.excmcaseproblem.form.idProblem')"
          filterable
          v-model="item.idProblem">
          <el-option v-for="option in problems"
                     class="select-default"
                     :value="option['@id']"
                     :label="option['title']"
                     :key="option['@id']">
          </el-option>
        </el-select>
      </fg-input>
    </div>
    <button
      type="submit"
      class="btn btn-success">{{$t('buttons.submit')}}</button>
  </form>
</template>

<script>
export default {
  props: {
    idCase: {
      type: String,
      required: false
    },
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      problems: []
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  created () {
    if (this.idCase) {
      this.item.idCase = this.idCase
    }
    this.getEXCMProblems()
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    getEXCMProblems () {
      let params = {
        'pagination': false
      }
      this.$http
        .get('api/e_x_c_m_problems', {
          params
        })
        .then(response => {
          this.problems = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    }
  }
}
</script>
